import { F0Icon } from '@factorialco/f0-react'
import { Proyector } from '@factorialco/f0-react/icons/app'
import { FinanceWorkspaceModuleRoutesVisibilityDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useTextSearch } from 'modules/core/hooks/useTextSearch'
import i18n from 'modules/core/lib/i18n'

import type { ResultType, SearchPlugin, SearchPluginHook } from 'modules/command_bar/lib/types'

const DEFAULT_SCORE = 0.2

type HeadcountPlanningNavigationResult = {
  id: string
  text: string
  IconComponent: ResultType['IconComponent']
  type: 'navigation'
  navigationPath: string
  score: number
}

const useHeadcountPlanning: SearchPluginHook = (search) => {
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(FinanceWorkspaceModuleRoutesVisibilityDocument)

  const canSeeHeadcountPlanning = data?.planning?._policies?.periodsCanSee?.can ?? false
  const navigationElements: HeadcountPlanningNavigationResult[] = canSeeHeadcountPlanning
    ? [
        {
          id: 'headcount-planning',
          text: i18n.t('planning.headcount_planning.title'),
          navigationPath: navigation.finance.financialWorkspace.headcountPlanning.fullPath(),
          type: 'navigation',
          score: DEFAULT_SCORE,
          IconComponent: () => <F0Icon icon={Proyector} />,
        },
      ]
    : []

  const { results } = useTextSearch(navigationElements, search, {
    fields: ['text'],
    storeFields: ['id', 'text', 'IconComponent', 'type', 'navigationPath'],
    fuzzy: 0.1,
    skipIndexing: loading,
  })
  const mappedResults: ResultType[] = results

  return {
    id: 'headcountPlanning',
    results: mappedResults,
    title: i18n.t('planning.headcount_planning.title'),
    loading,
  }
}

export const headcountPlanningPlugin: SearchPlugin = {
  hook: useHeadcountPlanning,
}
